export default __webpack_public_path__ + "static/media/AirbnbCerealMedium.8a9ee957.woff";